import React from 'react';
import { Uploader } from '../Uploader/Uploader';
import FileReqIcon from '../../images/anforderungen_icon.png';
import CloseIcon from '../../images/x_icon.png';
import BinIcon from '../../images/bin_icon.png';
import Dialog from '../Dialog/Dialog';
import CheckboxWithLabel from '../CheckboxWithLabel/CheckboxWithLabel';
import { getUploadErrorMessage } from '../General/ErrorHandler';
import ProgressView from '../ProgressView/ProgressView';
import { isReadableAsInt } from '../General/HelperFunctions';
import './FilePicker.less'

class FilePicker extends React.Component {
  uploadChecker = null
  uploadCheckerTimeout = null
  fileUploadRef = null
  uploadingProgress = []

  static defaultProps = {
      realm: null,
      companyID: null,
      canEdit: false,
      uploadPath: "/Files",
      outputFormat: 'gltf',
      inputFormats: ['fbx', 'obj', 'dae', 'stl', 'glb', 'gltf' , 'zip', 'dxf', 'wrl', 'step', 'stp', 'usdz'],
      minFileSize: 1,
      maxFileSize: 2000000000,//bytes //=2GB
      maxConvertedFileSize: 10000000, //byte //=10mb
      minFilenameSize: 4,
      maxFilenameSize: 50,
      allowedFilenameCharacters: /^([a-zA-Z0-9äöüÄÖÜ ._-]+)$/, // allows spaces inside a string and restricts special characters.It Only allows a-z, A-Z, 0-9, Space, Underscore and dash
      onUploadEnd: function(){},
      deleteModel: function(){},
      spaceLeft: 0,
      presetName1: "",
      presetName2: "",
      presetName3: "",
      presetFile1: null,
      presetFile2: null,
      presetFile3: null,
      timeout: 120000, // ca. 120000 -> 2min
      onClickShowFAQ: function(){},
  };

  constructor(props) {
      super(props);

      this.state = {
        dragOver: false,
        selectedFiles: [],
        uploadingFiles: [],
        errorFiles: [],
        outputFormat: this.props.outputFormat, //'gltf','glb'
        uploading: false, //'dropData','uploading','restrictions',
        progressBarState: 0,
        showingFileReq: false,
        adjustingScale: false,
        dropZonePageIndex: 0,
      };

      this.fileUploadRef = React.createRef();
      this.FilePositionWall = React.createRef();
      this.FilePositionFloor= React.createRef();
      this.FileKeepOffsetKeep= React.createRef();
      this.FileKeepOffsetCenter= React.createRef();
      this.originalScaleCheckbox= React.createRef();
      this.updateUploadValue = this.updateUploadValue.bind(this)
  }

  componentDidMount() {
    if (this.uploadChecker == null){
      this.uploadChecker = setInterval(() => {
        this.checkUploadProgress();
      }, 2000);
    }
  }

  componentWillUnmount(){
    if(this.uploadChecker != null){
      clearInterval(this.uploadChecker);
      this.uploadChecker = null;
    }
  }


  onFileChange(files, e){
    //NOTE:currently allowing only one file at a time! Later, a system with multiple files is planed
    if(files && files.length > 1){
      const { t } = this.props;
      Dialog.Alert({
        title: t('ThereWasAnError'),
        description: t('OnlyOneFileError'),
        options: [
            {label: t('OK'), className:"cancel"},
        ]
      })

      return;
    }
    let validFiles = [];
    if(files && files.length > 0){
      for (let index = 0; index < files.length; index++) {
        const file = files[index];
        if(this.fileIsValid(file)){
          validFiles.push({"File": file, "KeepOffset":false, "Scale":1.0, "Position": false, "Animate": false, "BaseUnit": "m", "UpAxis": 0, "ForwardAxis": 0})
        }
      }
    }

    this.setState({selectedFiles: validFiles, dragOver: false, showingFileReq: false});
    e.stopPropagation();
  };

  updateUploadValue(val, id)
  {
    var jobsFile = this.state.uploadingFiles.find((f) => f.ItemID === id);
    if (jobsFile != null)
      jobsFile["UploadProgress"] = val;

    this.forceUpdate();
  }

  onFileUpload = (e) => {
    if (this.state.selectedFiles == null || this.state.selectedFiles.length === 0) {
      const { t } = this.props;
      Dialog.Alert({
        title: t('ThereWasAnError'),
        description: t('NoFileError'),
        options: [
            {label: t('OK'), className:"cancel"},
        ]
      })
      return;
    }
    else {
        this.setState({uploading: true, dropZonePageIndex: 0})
        this.state.selectedFiles.forEach(file => {
            this.handleUploadFile(file, e.target);
        });
    }

    e.stopPropagation();
  };

  renewOngoingJobs()
  {
    if (this.uploadChecker == null)
      {
        this.uploadChecker = setInterval(() => {
          this.checkUploadProgress();
        }, 2000);
      }
  }

  handleUploadFile(file, htmlElem){
    const { t } = this.props;
    const selectedFile = file;
    if(this.props.realm && this.props.companyID && this.fileIsValid(file.File)){ //for security reasons, this is checked on file change and on file upload
      Uploader.addJob(
        this.props.realm,
        this.props.uploadPath,
        this.props.companyID,
        this.props.outputFormat,
        selectedFile.File.name.split(".")[0],
        file.KeepOffset ? "1" : "0",
        file.Scale,
        file.Position ? "1" : "0",
        file.Animate ? "1" : "0",
        "#eeeeee",
        file.BaseUnit,
        file.UpAxis ? 1 : 0,
        file.ForwardAxis ? 1 : 0,
        this.state.presetName1,
        this.state.presetFile1,
        this.state.presetName2,
        this.state.presetFile2,
        this.state.presetName3,
        this.state.presetFile3,
        )
        .then((resp) => {
          if (this.fileUploadRef != null && this.fileUploadRef.current != null)
          {
            this.fileUploadRef.current.value = null;
            this.setState({selectedFiles: [], dropZonePageIndex: 0});
          }
          if (this.uploadChecker == null)
          {
            this.uploadChecker = setInterval(() => {
              this.checkUploadProgress();
            }, 2000);
          }
          this.checkUploadProgress();
          Uploader.uploadFile(
            this.props.realm,
            selectedFile.File,
            this.props.uploadPath,
            this.props.companyID,
            resp.ItemID,
            this.updateUploadValue
          );
        })
        .catch((err) => {
          Dialog.Alert({
            title: t('ThereWasAnError'),
            description: err,
            options: [
                {label: t('OK'), className:"cancel"},
            ]
          })
          this.state.errorFiles.push({"File" : file, "Response": err, "Success" : false, "Reason": "Upload Failed"})
        })
    }else{
      this.state.errorFiles.push({"File" : file, "Response": null, "Success" : false, "Reason": "Values Not Valid"})
      htmlElem.dragOver = false;
    }
  }

  uploadTimeout(){
    const { t } = this.props;
    if(this.uploadChecker){
      Dialog.Alert({
        title: t('ThereWasAnError'),
        description: t('UploadError'),
        options: [
            {label: t('OK'), className:"cancel"},
        ]
      })
      this.resetUpload();
    }
  }

  resetUpload(full = false){
    /*

    */
    if (full)
    {
      clearInterval(this.uploadChecker);
      this.uploadCheckerTimeout = null;
      this.uploadChecker = null;
      this.setState({uploading: false, errorFiles: [], progressBarState: 0, uploadingFiles: [], dropZonePageIndex: 0})
    }
    else
    {
      if (this.fileUploadRef != null && this.fileUploadRef.current != null)
        this.fileUploadRef.current.value = null;
      this.setState({uploading: false, selectedFiles: [], errorFiles: [], progressBarState: 0, dropZonePageIndex: 0})
    }
  }

  updateJobProgess(newState)
  {
    if(newState >= 0){
      this.setState({progressBarState: newState})
    }
  }



  removeTrailingUnderscore(str) {
    if (str.endsWith('_')) {
      return str.slice(0, -1);
    }
    return str;
  }

  checkIfFileFinished(file){
    const { t } = this.props;
    let uploaded = [];
    Uploader.getJobState(file.ItemID,this.props.companyID)
    .then((resp) => {
    if (resp.Job["State"] === 1){
      uploaded.push(resp.Job)
      this.props.onUploadEnd(uploaded)
    }else if (resp.Job["State"] < 0){
      let filename = resp.Job["FileName"] ? this.removeTrailingUnderscore(resp.Job["FileName"]) : "-";
      let errorTitle = t('ThereWasAnError');
      let description = t('UploadErrorFailedFiles') + filename + resp.Job["OrigFileType"];
      let options = [{label: t('OK'), className:"cancel"}];
      let errorCode = resp.Job["Errors"];
      if(errorCode != null && errorCode !== "#"){
        description = filename + resp.Job["OrigFileType"] + ": "
        if(isReadableAsInt(errorCode)){
          let errTexts = getUploadErrorMessage(errorCode, t);
          errorTitle = errTexts["Title"];
          description += (errTexts["Description"] + " (Error: " + errorCode + ")");
          if(errorCode === 8200 || errorCode === 8400){
            options = [
              {label: t('FilePickerShowFAQ'), className:"dangerConfirm"},
              {label: t('OK'), className:"cancel"}
            ]
          }
        }else{
          description += resp.Job["Errors"];
        }
      }

      Dialog.Alert({
        title: errorTitle,
        description: description,
        options: options,
        panelOptions: {className: "vithrough"}
      }).then((optionChosen) => {
          if ((errorCode === 8200 || errorCode === 8400) && optionChosen === 0){
            this.props.onClickShowFAQ();
          }
      });

      this.props.onUploadEnd(uploaded)
    }})
    .catch((err) => {
      console.error(err);
    })
  }

  checkUploadProgress(){
    Uploader.getOngoingJobs(this.props.companyID)
    .then((resp) => {
      if(resp && resp.Jobs){
        this.state.uploadingFiles.forEach ((file) =>
        {
          var jobsFile = resp.Jobs.find((f) => f.ItemID === file.ItemID);
          if(jobsFile == null){
            this.checkIfFileFinished(file);
          }else{
            jobsFile["UploadProgress"] = file["UploadProgress"];
          }
        });
        this.setState({uploadingFiles: resp.Jobs});
      }
      else
      {
        this.state.uploadingFiles.forEach ((file)=>{
          this.checkIfFileFinished(file);
        });
        this.resetUpload(true);
      }
    })
    .catch((err) => {
      this.state.uploadingFiles.forEach ((file)=>
        {
          this.checkIfFileFinished(file);

        });
        this.resetUpload(true);
    })
  }

  fileIsValid(file){
    const { t } = this.props;
    if(!file || !file.name){
      Dialog.Alert({
        title: t('ThereWasAnError'),
        description: t('FileNotValidError'),
        options: [
            {label: t('OK'), className:"cancel"},
        ]
      })
      return false;
    }

    //TODO: In order to have the following messages translatable, we should think about a system which takes inputs in the dialog.alert function
    if(this.props.minFileSize != null && this.props.maxFileSize != null){
        if (!this.checkFileSize(file)) {
          Dialog.Alert({
            title: t('ThereWasAnError'),
            description: t('FileBadError', { '0': file.name, '1': this.formatFileSize(this.props.minFileSize), '2': this.formatFileSize(this.props.maxFileSize) }),
            options: [
                {label: t('OK')},
            ]
          })
            return false;
        }
    }

    if(this.props.minFilenameSize != null && this.props.maxFileSize != null){
        if(!this.checkFileName(file.name)){
          Dialog.Alert({
            title: t('ThereWasAnError'),
            description: t('FilenameBadError', { '0': file.name, '1': this.props.minFilenameSize, '2': this.props.maxFilenameSize }),
            options: [
                {label: t('OK')},
            ]
          })
            return false;
        }
    }

    if(!this.checkFileFormat(file.name)){
      Dialog.Alert({
        title: t('ThereWasAnError'),
        description: t('FileformatBadError', { '0': file.name, '1': this.props.inputFormats }),
        options: [
            {label: t('OK')},
        ]
      })

      return false;
    }

    return true;
  }

formatFileSize(bytes, decimalPoint) {
  if(bytes === 0) return '0 Bytes';
  var k = 1000,
      dm = decimalPoint || 2,
      sizes = ['Byte(s)', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
      i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}

checkFileFormat(filename){
  let extension = filename.split('.').pop();
  if(this.props.inputFormats.includes(extension.toLowerCase())){
    return true;
  }
  return false;
}


checkFileSize(file){
    if(file.size > this.props.maxFileSize || file.size < this.props.minFileSize){
        return false;
    }

    return true;
}

checkFileName(filename){
    if(filename == null || filename === "" || !this.checkFileNamePoints(filename)){
        return false;
    }

    let nameParts = filename.split(".");
    let firstNamePart = nameParts[0];

    if(firstNamePart.length > this.props.maxFilenameSize || firstNamePart.length < this.props.minFilenameSize || !this.checkFilenameCharacters(firstNamePart)){
        return false;
    }

    return true;
}

checkFileNamePoints(filename){
    let filenameParts = filename.split(".");
    if(filenameParts.length > 2){
        return false;
    }

    return true;
}

checkFilenameCharacters(filename){
    if(!this.props.allowedFilenameCharacters.exec(filename)){
        return false;
    }
    return true;
}

  getPendingJobs = (self) => {
    Uploader.getPendingJobs((data) => {
      self.setState({ itemID: data.data[0].ItemID })

      self.getJob(self);
    })
  }

  getJob = (self) => {
    Uploader.getJob(self.state.itemID);
  }

  dropHandler(ev) {
    ev.preventDefault();
    const files = [];

    if (ev.dataTransfer.items) {
      // Use DataTransferItemList interface to access the file(s)
      [...ev.dataTransfer.items].forEach((item, i) => {
        // If dropped items aren't files, reject them
        if (item.kind === "file") {
          files.push(item.getAsFile());
        }
      });
    } else {
      // Use DataTransfer interface to access the file(s)
      [...ev.dataTransfer.files].forEach((file, i) => {
        files.push(file);
      });
    }

    this.onFileChange(files, ev);
  }

  dragOverHandler(ev) {
    if(!this.state.dragOver){
      this.setState({dragOver: true});
    }
    ev.preventDefault();
    ev.stopPropagation();
  }

  dragEnterHandler(e){
    this.setState({dragOver: true});
    e.preventDefault();
  }

  dragLeaveHandler(e){
    if(this.state.dragOver){
      this.setState({dragOver: false});
    }
    e.preventDefault();
    e.stopPropagation();
  }

  updateFileCheckBoxValue(e, idx, property, value){
    const c = Object.assign({}, this.state);
    if(c.selectedFiles[idx]){
      c.selectedFiles[idx][property] = value;
      this.setState(c);
    }
    e.stopPropagation();
  }

  setFileScaleValue(e, idx, value, newChecked){
    const c = Object.assign({}, this.state);
    if(e && c.selectedFiles[idx]){
      if(newChecked){
        //this.setScaleAdjustment(e, false)
        c.selectedFiles[idx]["Scale"] = (value/100);
      }else{
        c.adjustingScale = true;
      }
      this.setState(c);
    }
    e.stopPropagation();
  }

  updateFileScaleValue(e, idx){
    const c = Object.assign({}, this.state);
    if(e && e.target && c.selectedFiles[idx]){
      c.selectedFiles[idx]["Scale"] = (e.target.value/100);
      this.setState(c);
    }
    e.stopPropagation();
  }

  showFileRequirements(e){
    e.preventDefault();
    this.setState({showingFileReq: !this.state.showingFileReq})
    e.stopPropagation();
  }

  uploadThroughHtmlElement(e){
    if (this.state.dropZonePageIndex === 2) return;
    if(this.state.adjustingScale){
      this.setScaleAdjustment(e, false)
    }else if(this.state.selectedFiles.length === 0){
      this.fileUploadRef.current.click()
      e.stopPropagation();
    }
  }

  setScaleAdjustment(e, active){
    this.setState({adjustingScale: active})
  }

  getStateDesciption(loadState){
    const { t } = this.props;
    if(loadState < 0){
      return t('LoadError');
    }else{
      switch(loadState){
        case 0:
          return t('Uploading');
        case 1:
          return t('LoadUploadFinished');
        case 2:
          return t('LoadQueued');
        case 3:
          return t('LoadServerGetFiles');
        case 4:
          return t('LoadConvert');
        case 5:
          return t('LoadDeploy');
        default:
          return t('LoadError');
      }
    }
  }

  render() {
    const { t, i18n } = this.props;
    const state = this.state;
    const props = this.props;
    const filesSelected = state.selectedFiles && state.selectedFiles.length !== 0;
    const uploadButtonState = filesSelected ? (state.dropZonePageIndex < 1 || (this.props.companyID === "B5F90040-0EBE-4E77-9B24-107F40DC9596" && state.dropZonePageIndex < 2) ? "selected" : "upload") : "empty";

    return (
      <div className='filepicker_main'>
      <div id='file_picker' className='file_picker'>
        <div id='pickerContent' className='pickerContent'>
          <div
            id='drop_zone'
            className={state.dragOver ? "drop_zone_dragOver" : "drop_zone"}
            onDrop={(e) => this.dropHandler(e)}
            onDragOver={(e) => this.dragOverHandler(e)}
            onDragLeave={(e) => this.dragLeaveHandler(e)}
            onDragEnd={(e) => this.dragLeaveHandler(e)}
            onClick={(e) => {this.uploadThroughHtmlElement(e)}}
            >
            <div className='drop_zone_content'>
              <div className='file_requirements'>
                  <div className='file_requirements_tooltip'>
                    {t('FileReqText')}
                  </div>
              </div>
              <button className='file_requirements_button' id='file_requirements_button_id' title={t('FileReqButton')} onClick={(e) => this.showFileRequirements(e)}>
                <img alt="" src={state.showingFileReq ? CloseIcon : FileReqIcon}/>
              </button>
              {!filesSelected && !state.showingFileReq && <label id='description' className='description'>{!(props.spaceLeft > state.uploadingFiles.length) ? t('ModelLimit1') : t('FileReq')}</label>}
              {!filesSelected && !state.showingFileReq && <label id='drop_zone_hint' className='drop_zone_hint'>{!(props.spaceLeft > state.uploadingFiles.length) ? t('ModelLimit2'): t('DropFile')}</label>}
              {filesSelected && !state.showingFileReq &&
                  state.selectedFiles.map((file, idx) => {
                    const selectedFile = file.File;
                    return (
                      <div className='file_data' key={"file_data-" + idx}>
                        {
                          this.state.dropZonePageIndex !== 2 &&
                          <label className='labelTitle'>{t('FileName')}</label>
                        }
                        {
                          this.state.dropZonePageIndex !== 2 &&
                          <div style={{display: "flex", flexDirection: "row", justifyContent: "center"}}>
                          <div>
                          <label>{selectedFile.name}</label>
                          </div>
                          <div>
                          <button title={t('Delete')} onClick={(e)=> {this.resetUpload();}} style={{marginLeft: '0.5em'}}><img alt={t('Delete')} src={BinIcon}/></button>
                          </div>
                        </div>
                      }
                        {this.state.dropZonePageIndex === 0 &&
                        <div className='file_data_list'>
                          <div className='file_data_element'>
                          <div title={t('FilePosition_Help')}><label>{t('FilePosition_Headline')}</label></div>
                            <div style={{width: "4.5rem"}}>
                              <CheckboxWithLabel
                                checkboxPosition="right"
                                labelContent={t('FilePositionWall')}
                                onClick={(e, newChecked) => this.updateFileCheckBoxValue(e, idx, "Position", newChecked)}
                                checked={file["Position"]}
                                value={file["Position"]}
                              />
                              <CheckboxWithLabel
                                checkboxPosition="right"
                                checked={!file["Position"]}
                                labelContent={t('FilePositionFloor')}
                                onClick={(e, newChecked) => this.updateFileCheckBoxValue(e, idx, "Position", !newChecked)}
                              />
                            </div>
                          </div>
                          <div className='file_data_element'>
                          <div title={t('FileKeepOffset_Help')}><label>{t('FileKeepOffset')}</label></div>
                            <div style={i18n.language === "en" ?{width: "5.5rem"} : {width: "7rem"}}>
                              <CheckboxWithLabel
                                checkboxPosition="right"
                                checked={file["KeepOffset"]}
                                labelContent={t('FileKeepOffsetKeep')}
                                onClick={(e, newChecked) => this.updateFileCheckBoxValue(e, idx, "KeepOffset", newChecked)}
                              />
                              <CheckboxWithLabel
                                checkboxPosition="right"
                                checked={!file["KeepOffset"]}
                                onClick={(e, newChecked) => this.updateFileCheckBoxValue(e, idx, "KeepOffset", !newChecked)}
                                labelContent={t('FileKeepOffsetCenter')}
                              />
                            </div>
                          </div>
                          <div className='file_data_element'>
                            <div title={t('FileScale_Help')}><label>{t('FileScale')}</label></div>
                            <div style={i18n.language === "en" ? {width: "7rem"} : {width: "7.5rem"}}>
                              <CheckboxWithLabel
                                checkboxPosition="right"
                                value={(file["Scale"] === 1.0)}
                                checked={(file["Scale"] === 1.0)}
                                labelContent={t('FileScaleOriginal')}
                                onClick={(e, newChecked) => this.setFileScaleValue(e, idx, 100, newChecked)}
                              />
                              <div className='flex_data_element_scaling'>
                                <label className='file_data_element_option'>{t('FileScaleCustom')} (%): </label>
                                <input  style={{width: '3em'}} type="number" value={Math.round(file["Scale"]*100).toString()} min="1" step="1" pattern="\d*" onBlur={() => this.setState({adjustingScale: false})} onClick={(e) => {e.stopPropagation();}} onChange={(e) => this.updateFileScaleValue(e, idx)}></input>
                              </div>
                            </div>
                          </div>
                        </div>}
                        {this.state.dropZonePageIndex === 1 &&
                        <div className='file_data_list'>
                          <div className='file_data_element'>
                            <div title={t('FilePickerUnits_Help')}><label>{t('FilePickerUnitsTitle')}</label></div>
                            <div style={{width: "7rem"}}>
                              <CheckboxWithLabel
                                checkboxPosition="right"
                                labelContent={t('ModelSettingsUnitMM')}
                                onClick={(e, newChecked) => this.updateFileCheckBoxValue(e, idx, "BaseUnit", "mm")}
                                checked={file["BaseUnit"] === "mm"}
                                value={file["BaseUnit"]  === "mm"}
                                />
                              <CheckboxWithLabel
                                checkboxPosition="right"
                                checked={file["BaseUnit"] === "cm"}
                                value={file["BaseUnit"] === "cm"}
                                labelContent={t('ModelSettingsUnitCM')}
                                onClick={(e, newChecked) => this.updateFileCheckBoxValue(e, idx, "BaseUnit", "cm")}
                              />
                              <CheckboxWithLabel
                                checkboxPosition="right"
                                labelContent={t('ModelSettingsUnitM')}
                                onClick={(e, newChecked) => this.updateFileCheckBoxValue(e, idx, "BaseUnit", "m")}
                                checked={file["BaseUnit"] === "m"}
                                value={file["BaseUnit"] === "m"}
                              />
                            </div>
                          </div>
                          <div className='file_data_element'>
                            <div title={t('FilePickerAxis_Help')}><label>{t('FilePickerAxisTitle')}</label></div>
                            <div style={{width: "2rem"}}>
                              <CheckboxWithLabel
                                checkboxPosition="right"
                                checked={!file["UpAxis"]}
                                value={!file["UpAxis"]}
                                labelContent="Y"
                                onClick={(e, newChecked) => this.updateFileCheckBoxValue(e, idx, "UpAxis", newChecked ? 0 : 1)}
                              />
                              <CheckboxWithLabel
                                checkboxPosition="right"
                                checked={file["UpAxis"]}
                                value={file["UpAxis"]}
                                onClick={(e, newChecked) => this.updateFileCheckBoxValue(e, idx, "UpAxis", newChecked ? 1 : 0)}
                                labelContent="Z"
                              />
                            </div>
                          </div>
                          <div className='file_data_element'>
                            <div title={t('FilePickerFwAxis_Help')}><label>{t('FilePickerFwAxisTitle')}</label></div>
                            <div style={{width: "3rem"}}>
                              <CheckboxWithLabel
                                checkboxPosition="right"
                                checked={!file["ForwardAxis"]}
                                value={!file["ForwardAxis"]}
                                labelContent={file["UpAxis"] === 0 ? "-Z" : "-Y"}
                                onClick={(e, newChecked) => this.updateFileCheckBoxValue(e, idx, "ForwardAxis", newChecked ? 0 : 1)}
                              />
                              <CheckboxWithLabel
                                checkboxPosition="right"
                                checked={file["ForwardAxis"]}
                                value={file["ForwardAxis"]}
                                onClick={(e, newChecked) => this.updateFileCheckBoxValue(e, idx, "ForwardAxis", newChecked ? 1 : 0)}
                                labelContent={file["UpAxis"] === 0 ? "Z" : "Y"}
                              />
                            </div>
                          </div>
                        </div>}
                        {this.state.dropZonePageIndex === 2 &&
                          <div className='file_data_list' style={{gap: '0.9rem', width: "80%", flexDirection: 'column', zIndex: '9001', pointerEvents: 'all'}}>
                            <div className='file_data_element' style={{width: "70%"}}>
                              <input type='text'
                              className='file_input'
                              value={this.state.presetName1}
                              onChange={(e) => this.setState({presetName1: e.target.value})}/>
                              <input className='file_input' type='file' style={{paddingLeft: "0px", paddingTop: "0.1rem"}}
                              onChange={(e) => this.setState({presetFile1: e.target.files[0]})}/>
                            </div>
                            <div className='file_data_element' style={{width: "70%"}}>
                              <input
                              className='file_input'
                              type='text'
                              value={this.state.presetName2}
                              onChange={(e) => this.setState({presetName2: e.target.value})}/>
                              <input className='file_input' type='file' style={{paddingLeft: "0px", paddingTop: "0.1rem"}}
                              onChange={(e) => this.setState({presetFile2: e.target.files[0]})}/>
                            </div>
                            <div className='file_data_element'style={{width: "70%"}}>
                              <input className='file_input' type='text'
                              value={this.state.presetName3}
                              onChange={(e) => this.setState({presetName3: e.target.value})}/>
                              <input className='file_input' type='file' style={{paddingLeft: "0px", paddingTop: "0.1rem"}}
                              onChange={(e) => this.setState({presetFile3: e.target.files[0]})}/>
                            </div>
                          </div>
                        }
                      </div>
                    )})
              }
              {state.showingFileReq &&
                <div className='file_requirements_tooltip' style={{fontSize: '0.9em', lineHeight: '1.0em', padding: '0 1em 2em 1em', fontWeight: 'normal'}}>
                  {t('FileReqText')}
                </div>}
              {state.uploading && !state.showingFileReq && false &&
                <div id="progressbar">

                  <label>{this.getStateDesciption(state.progressBarState)}</label>

                  <div id="progressbar_bar" style={{width: (state.progressBarState/6) * 100 + "%"}}></div>
                </div>}
            </div>
            {uploadButtonState === "empty" &&
                <button className='upload_button armodelviewer_button upload' disabled={!props.canEdit || !(props.spaceLeft > state.uploadingFiles.length)} title={!(props.spaceLeft > state.uploadingFiles.length) ? t('ModelLimit1') : t('SelectFile')} onClick={(e) => {this.uploadThroughHtmlElement(e)}}>
                  {t('SelectFile')}
                </button>}
            {uploadButtonState === "selected" &&
                <button className='upload_button armodelviewer_button upload' disabled={!props.canEdit || !(props.spaceLeft > state.uploadingFiles.length)} title={!(props.spaceLeft > state.uploadingFiles.length) ? t('ModelLimit1') : t('SelectFile')} onClick={(e) => {this.setState({dropZonePageIndex: state.dropZonePageIndex + 1})}}>
                  {t('FilePickerNextPage')}
                </button>}
            {uploadButtonState === "upload" &&
                <button className='upload_button armodelviewer_button upload' disabled={!props.canEdit || !(props.spaceLeft > state.uploadingFiles.length)} title={!(props.spaceLeft > state.uploadingFiles.length) ? t('ModelLimit1') : t('Upload')} onClick={(e) => this.onFileUpload.bind(this)(e)}>
                  {t('Upload')}
                </button>}
            <input type="file" disabled={!props.canEdit || !(props.spaceLeft > state.uploadingFiles.length)} onChange={(e)=>this.onFileChange(e.target.files, e)} ref={this.fileUploadRef} hidden/>
          </div>
          {
            filesSelected &&
            <div className='drop_zone_page_selection' id='drop_zone_page_selection'>
              <div className={state.dropZonePageIndex === 0 ? 'drop_zone_button_selected left_button' : 'drop_zone_button left_button'} onClick={() => this.setState({dropZonePageIndex: 0})}>
                <label>{t('FilePickerPage1Title')}</label>
              </div>
              <div className={state.dropZonePageIndex === 1 ? 'drop_zone_button_selected right_button' : 'drop_zone_button right_button'} onClick={() => this.setState({dropZonePageIndex: 1})}>
                	<label>{t('FilePickerPage2Title')}</label>
              </div>
              {
                this.props.companyID === "B5F90040-0EBE-4E77-9B24-107F40DC9596" &&
                <div className={state.dropZonePageIndex === 2 ? 'drop_zone_button_selected right_button' : 'drop_zone_button right_button'} onClick={() => this.setState({dropZonePageIndex: 2})}>
                	<label>{t('FilePickerPage3Title')}</label>
              </div>
              }
            </div>
          }
        </div>
        </div>
        {
          state.uploadingFiles.length > 0 &&
          <ProgressView
            deleteModel={(itemID) => props.deleteModel(itemID)}
            files = {state.uploadingFiles}
          />
        }
      </div>
    );
  }
}

export default FilePicker;
